import { Link } from 'react-router-dom';
import {
  Dropdown,
  DropdownDivider,
  DropdownHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'react-bootstrap';
import IconifyIcon from '../../../../components/wrappers/IconifyIcon';
import { useAuth } from '../../../../context/AuthContext';

const ProfileDropdown = () => {
  const { admin, logout } = useAuth();
  const name = admin?.email || admin?.mobile || 'Admin';
  const avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&size=64`;

  return (
    <Dropdown className="topbar-item" align="end">
      <DropdownToggle
        as="button"
        type="button"
        className="topbar-button content-none"
        id="page-header-user-dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span className="d-flex align-items-center">
          <img className="rounded-circle" width={32} height={32} src={avatarUrl} alt="Avatar" />
        </span>
      </DropdownToggle>
      <DropdownMenu>
        <DropdownHeader as="h6">{admin?.mobile ? `Welcome, ${admin.mobile}` : 'Welcome!'}</DropdownHeader>
        <DropdownItem as={Link} to="/dashboard">
          <IconifyIcon icon="bx:user-circle" className="text-muted fs-18 align-middle me-1" />
          <span className="align-middle">Profile</span>
        </DropdownItem>
        <DropdownItem as={Link} to="/dashboard">
          <IconifyIcon icon="bx:message-dots" className="text-muted fs-18 align-middle me-1" />
          <span className="align-middle">Messages</span>
        </DropdownItem>
        <DropdownDivider className="dropdown-divider my-1" />
        <DropdownItem as="button" className="text-danger" onClick={logout}>
          <IconifyIcon icon="bx:log-out" className="fs-18 align-middle me-1" />
          <span className="align-middle">Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
